import getCookie from "./helpers/getCookie";
import setCookie, {setCookieUnixTimestamp} from "./helpers/setCookie";

async function inpostPayBinding() {
  // Wait for nonces to load before making AJAX request
  // Prevents 403 errors when page loads from cache with stale nonces
  await new Promise((resolve) => {
    if (window.inpostPayWaitForNonces) {
      window.inpostPayWaitForNonces(resolve);
    } else {
      // Fallback: if nonceLoader.js not loaded, continue anyway
      console.warn('[InPostPay] nonceLoader.js not loaded - nonce may be missing');
      resolve();
    }
  });

  try {
    let data = new FormData();

    let basketBindingApiKey = getCookie("basket_binding_api_key");
    if (basketBindingApiKey) {
      data.append("basket_binding_api_key", basketBindingApiKey);
    }

    // Add CSRF nonce for inpost_pay_bind endpoint
    if (window.inpostPayNonces && window.inpostPayNonces.payBind) {
      data.append("_ajax_nonce", window.inpostPayNonces.payBind);
    } else {
      console.error('[InPostPay] Nonce missing - AJAX request will fail with 403');
    }

    const response = await fetch(InpostIziJavsscriptWoocommerce.inpost_pay_bind, {
      method: "POST",
      credentials: "same-origin",
      body: data
    });

    if (!response.ok) {
      return;
    }

    try {
      const responseData = await response.json();
      if (responseData.success && responseData.data && responseData.data.basket_binding_api_key) {
        IPPWidgetOptions.basketBindingApiKey = responseData.data.basket_binding_api_key;
        const existingBasketBindingApiKey = getCookie("basket_binding_api_key");
        if (!existingBasketBindingApiKey) {
          setCookieUnixTimestamp(
            "basket_binding_api_key",
            responseData.data.basket_binding_api_key,
            responseData.data.session_expiration,
          );
        }
      }
    } catch (jsonError) {
      console.warn('[InPostPay] Failed to parse bind response JSON:', jsonError);
    }
  } catch (error) {
    console.warn('[InPostPay] Bind error:', error);
  }
}

export { inpostPayBinding };
